import {ReactElement, useState} from 'react'

import {ModalContainer} from '../../ModalContainer'
import {ChooseReasonModalContent} from './ChooseReasonModalContent'
import {OtherRefundIssueContent} from './OtherRefundIssueContent'
import {CantAccessDepositMethodIssueContent} from './CantAccessDepositMethodIssueContent'
import {ContactSupportModalSteps} from './constants'
import {useStyles} from './styles'
import {RefundWithdrawSchemaItem} from '../../types'

type ContactSupportModalProps = {
  accountId: number,
  isOpen: boolean,
  clientId: number,
  refundWithdrawSchema: RefundWithdrawSchemaItem[],
  onClose: () => void,
  onlySelectPaymentMethodFlow: boolean,
  onDepositMethodVerificationSubmittedModalOpen: () => void,
}

function ContactSupportModal(props: ContactSupportModalProps): ReactElement {
  const {
    accountId,
    isOpen,
    clientId,
    refundWithdrawSchema,
    onlySelectPaymentMethodFlow,
    onClose,
    onDepositMethodVerificationSubmittedModalOpen,
  } = props
  const classes = useStyles()
  const defaultModalStep = onlySelectPaymentMethodFlow
    ? ContactSupportModalSteps.otherRefundIssues
    : ContactSupportModalSteps.chooseReason

  const [modalStep, setModalStep] = useState<ContactSupportModalSteps>(defaultModalStep)

  const handleChooseReasonRedirect = () => setModalStep(ContactSupportModalSteps.chooseReason)
  const handleOtherRefundIssuesRedirect = () => setModalStep(ContactSupportModalSteps.otherRefundIssues)
  const handleCantAccessDepositMethodIssueRedirect = () => setModalStep(ContactSupportModalSteps.cantAccessDepositMethodIssue)

  const handleOtherRefundIssueContentClose = () => {
    if (onlySelectPaymentMethodFlow) {
      onClose()
      return
    }

    handleChooseReasonRedirect()
  }

  const handleClose = () => {
    onClose()
    handleChooseReasonRedirect()
  }

  return (
    <ModalContainer isOpen={isOpen} onClose={handleClose}>
      <div className={classes.content}>
        {modalStep === ContactSupportModalSteps.chooseReason ? (
          <ChooseReasonModalContent
            onOtherRefundIssuesRedirect={handleOtherRefundIssuesRedirect}
            onCantAccessDepositMethodIssueRedirect={handleCantAccessDepositMethodIssueRedirect}
            onClose={handleClose}
          />
        ) : null}
        {modalStep === ContactSupportModalSteps.otherRefundIssues ? (
          <OtherRefundIssueContent onClose={handleOtherRefundIssueContentClose} />
        ) : null}
        {modalStep === ContactSupportModalSteps.cantAccessDepositMethodIssue ? (
          <CantAccessDepositMethodIssueContent
            accountId={accountId}
            clientId={clientId}
            refundWithdrawSchema={refundWithdrawSchema}
            onClose={handleClose}
            onChooseReasonRedirect={handleChooseReasonRedirect}
            onDepositMethodVerificationSubmittedModalOpen={onDepositMethodVerificationSubmittedModalOpen}
          />
        ) : null}
      </div>
    </ModalContainer>
  )
}

export {ContactSupportModal}
